// @ts-nocheck
import AboutCompany from './components/AboutUs/AboutCompany';
import WhyChoose from './components/AboutUs/WhyChoose';
import Contact from './components/Contact';
import DealerModal from './components/DealerModal';
import Footer from './components/Footer';
import Header from './components/Header';
import Hero from './components/Hero';
import MarketOpportunity from './components/Market/MarketOpportunity';
import AboutHass from './components/Product/AboutHass';
import AvoprimeProduct from './components/Product/AvoprimeProduct';
import Comparison from './components/Product/Comparison';
import HarvestWindow from './components/Product/HarvestWindow';
import RipenessGuide from './components/Product/RipenessGuide';

const App = () => {
  return (
    <div className='App'>
      <Header />
      <main>
        <section
          id='hero'
          className='bg-gradient-to-br from-avoprime-primary via-avoprime-secondary to-avoprime-dark'
        >
          <Hero />
        </section>

        {/* Sobre nós */}
        <section id='about-company' className='bg-slate-50'>
          <AboutCompany />
        </section>

        <section id='harvest' className='bg-slate-50'>
          <HarvestWindow />
        </section>

        <section id='why-choose' className='bg-white'>
          <WhyChoose />
        </section>

        <section id='product-avoprime'>
          <AvoprimeProduct />
        </section>
        
        <section id='comparison' className='bg-white'>
          <Comparison />
        </section>

        <section id='about-hass' className='bg-white'>
          <AboutHass />
        </section>

        <section id='ripeness-guide' className='bg-slate-50'>
          <RipenessGuide />
        </section>



        {/* Mercado */}
        <section id='market-opportunity' className='bg-slate-50'>
          <MarketOpportunity />
        </section>

        <section id='contact' className='bg-white'>
          <Contact />
        </section>
      </main>
      <Footer />
      <DealerModal />
    </div>
  );
};

export default App;
